export enum WebsiteProgramDateFilter {
    TODAY = 'today',
    ALL = 'all'
}

export const WEBSITE_PROGRAM_DATE_FILTERS: WebsiteProgramDateFilter[] = [
    WebsiteProgramDateFilter.TODAY,
    WebsiteProgramDateFilter.ALL
];
